import * as actionTypes from './actionType';

export const setHotelDataSUCCESS = (payload: any) => ({
    type: actionTypes.SET_HOTEL_SUCCESS,
    payload,
});
export const setHotelSelected = (payload: any) => ({
    type: actionTypes.SET_HOTEL_SELECTED,
    payload,
});
export const setHotelLightboxDest = (payload: any) => ({
    type: actionTypes.SET_HOTEL_LIGHTBOXDEST,
    payload,
});
